const NotFound = () => {
  return (
    <div className="absolute inset-0 flex items-center w-full h-full text-center justify-items-center">
      <span className="mx-auto">404 - Page not found</span>
    </div>
  );
};

export default NotFound;
